<template>
  <div id="app" :style="{overflow: phoneMenu ? 'hidden' : 'auto', height: phoneMenu ? '100%' : 'auto'}">
    <el-container>
      <!-- pc 头部 -->
      <div class="mc_pc_hd" :class="{hasBanner: hasBanner}">
        <el-header>
          <div class="logo">
            <img src="./assets/image/menuLogo1.png" alt>
          </div>
          <el-menu
            :default-active="$route.path"
            text-color="#fff"
            active-text-color="#EA6828"
            class="el-menu-demo"
            mode="horizontal"
            :router="router"
            @select="handleSelect"
          >
            <template v-for="item in menu">
              <el-menu-item v-if="item.children.length == 0" :key="item.key" :index="'/'+item.key">{{ $t('lang.' + item.key) }}</el-menu-item>
              <el-submenu v-else :key="item.key" :index="'/'+item.key" :show-timeout="subMenuTimeOut" :hide-timeout="subMenuTimeOut">
                <template slot="title">{{ $t('lang.' + item.key) }}</template>
                <el-menu-item v-for="item1 in item.children" :key="item1.key" :index="item.key == 'contactUs' ? ('/' + item1.key) : ('/' + item.key+'/'+item1.key)">{{ $t('lang.' + item1.key) }}</el-menu-item>
              </el-submenu>
            </template>
          </el-menu>

          <a href="javascript:void(0)" class="mc_navbar_r" @click="choseLanguage">
            <img src="./assets/image/xtb_globle.png">
            <div>
              <span :class="{active: $i18n.locale == 'zh'}">中</span>
              <span style="padding-left: 4px;padding-right: 4px">|</span>
              <span :class="{active: $i18n.locale == 'en'}">EN</span>
            </div>
          </a>
        </el-header>
      </div>

      <!-- phone 头部 -->
      <div class="mc_ph_hd">
        <el-header>
          <div class="logo">
            <img src="./assets/image/menuLogo.png" alt>
          </div>
          <div class="flex-row-left">
            <div id="mbtn" :class="{active: phoneMenu}" class="point" @click="showPhoneMenu">
              <span class="nav_btn" />
            </div>
          </div>
        </el-header>
        <div :class="{show: phoneMenu}" class="phone-menu flex-column-left">
          <el-col :span="24">
            <el-menu
              :default-active="$route.path"
              text-color="#fff"
              active-text-color="#EA6828"
              :router="router"
              @select="handleSelect"
            >
              <template v-for="item in menu">
                <el-menu-item v-if="item.children.length == 0" :key="item.key" :index="'/'+item.key">{{ $t('lang.' + item.key) }}</el-menu-item>
                <el-submenu v-else :key="item.key" :index="'/'+item.key" :show-timeout="subMenuTimeOut" :hide-timeout="subMenuTimeOut">
                  <template slot="title">{{ $t('lang.' + item.key) }}</template>
                  <el-menu-item v-for="item1 in item.children" :key="item1.key" :index="item.key == 'contactUs' ? ('/' + item1.key) : ('/' + item.key+'/'+item1.key)">{{ $t('lang.' + item1.key) }}</el-menu-item>
                </el-submenu>
              </template>
            </el-menu>
          </el-col>
          <div class="flex-row-center ph-ft-language">
            <span>{{ $t('lang.choseLanguage') }}：</span>
            <a href="javascript:void(0)" class="mc_navbar_r" @click="choseLanguage">
              <span :class="{active: $i18n.locale == 'zh'}">中文</span>
              <span style="padding-left: 4px;padding-right: 4px">|</span>
              <span :class="{active: $i18n.locale == 'en'}">EN</span>
            </a>
          </div>
        </div>
      </div>
      <el-main>
        <router-view @checkBanner="checkBanner" />
      </el-main>
    </el-container>

    <footer class="mc_ft pc-mc_ft">
<!--      <div class="mc_ft1">-->
<!--        <div class="mc_cont1520 clearfix">-->
<!--          &lt;!&ndash; logo &ndash;&gt;-->
<!--          <div class="mc_ft1_l">-->
<!--            <div class="logo">-->
<!--              <img src="./assets/image/menuLogo.png" alt>-->
<!--            </div>-->
<!--          </div>-->

<!--          &lt;!&ndash; 导航 &ndash;&gt;-->
<!--          <div class="mc_ft1_navbox">-->
<!--            <ul class="mc_ft1_nav clearfix">-->
<!--              <li v-for="item in footMenu" :key="item.key" class="mc_ft1_li mc_ft1_li1">-->
<!--                <a class="mc_ft1_a">-->
<!--                  {{ $t('lang.' + [item.key]) }}-->
<!--                </a>-->
<!--                <ul class="mc_ft1_subnav clearfix">-->
<!--                  <li v-for="item1 in item.children" :key="item1.key">-->
<!--                    <router-link :to="item.key == 'contactUs' ? '/'+item1.key : '/'+item.key+'/'+item1.key">-->
<!--                      <a href="" class="mc_ft1_suba">{{ $t('lang.' + [item1.key]) }}</a>-->
<!--                    </router-link>-->
<!--                  </li>-->
<!--                </ul>-->
<!--              </li>-->
<!--            </ul>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
      <div class="mc_ft2">
        <div class="mc_cont100 clearfix">
          <div class="mc_ft_copyright">
            <p>
              COPYRIGHT (C) 2023 江苏瞬电网络科技有限公司. 版权所有
              <a class="ft_address" href="http://beian.miit.gov.cn/" target="_blank">苏ICP备2023014694号</a>
              <a class="mc_pby" target="_blank" />
            </p>
            <p class="mc_cnzz" style="display: none;">&nbsp;</p>
          </div>
        </div>
      </div>
    </footer>

    <footer class="mc_ft ph-mc_ft">
      <div class="mc_ft_copyright flex-row-right">
        <p>
          COPYRIGHT (C) 2023 江苏瞬电网络科技有限公司. 版权所有
          <a class="ft_address" href="http://beian.miit.gov.cn/" target="_blank">苏ICP备2023014694号</a>
          <a class="mc_pby" target="_blank" />
        </p>
      </div>
    </footer>
  </div>
</template>

<script>
import { menu } from './utils/config'
import './assets/scss/main.scss'
import './assets/scss/index.scss'

export default {
  data() {
    return {
      router: true,
      defaultActive: '/home',
      isShow: false,
      subMenuTimeOut: 100,
      menu: [],
      footMenu: [],
      phoneMenu: !1,
      hasBanner: !1,
      hideFooter: !1
    }
  },
  mounted() {
    this.initMenu()
  },
  methods: {
    initMenu() {
      this.menu = menu
      this.footMenu = menu.filter(function(item) { return item.children.length > 0 })
    },

    handleSelect(key) {
      this.isShow = this.defaultActive != key
      this.phoneMenu = !1
    },

    choseLanguage() {
      const language = this.$root.$i18n.locale == 'zh' ? 'en' : 'zh'
      this.$root.$i18n.locale = language
      window.sessionStorage.setItem('language', language)
      this.phoneMenu = !1
      if (this.$route.path == '/home') {
        this.$router.go(0)
      } else {
        this.$router.push('/home')
      }
    },

    showPhoneMenu() {
      this.phoneMenu = !this.phoneMenu
    },

    checkBanner(e) {
      this.hasBanner = e
    }
  }
}
</script>

<style lang="scss">
.phone-menu {
  top: 60px;
  position: fixed;
  z-index: 1000;
  width: 100%;
  height: 100%;
  background: #595758 !important;
  overflow: visible;
  padding: 0 20px;
  color: #fff;
  left: 100%;
  transition: all .5s ease-out;
  opacity: 0;

  &.show {
    left: 0;
    opacity: 1;
  }
  .el-col {
    height: calc(100% - 120px);
    >.el-menu {
      background: #595758 !important;
      border-right: none !important;
      width: 100%;
      height: 100%;
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
      padding-bottom: 15px;
      overflow: auto;
      >li {
        background: none !important;
        border-bottom: 1px solid #ffffff;
        &:hover {background: #595758 !important;}
        &:focus {background: #595758 !important;}
      }
      .el-submenu {
        .el-submenu__title {
          &:hover {background: none !important;}
          &:focus {background: none !important;}
          >i {color: #ffffff !important;}
        }
        .el-menu {
          >li {
            font-size: 12px !important;
            background: none !important;border-bottom: 1px solid #ffffff;
            &:last-child {border-bottom: none}
          }
          background: none !important;
          padding-left: 20px;
        }
        &.is-active {.el-submenu__title {color: #EA6828 !important;}}
      }
    }

  }

  .ph-ft-language {
    line-height: 60px;
    width: 100%;
    z-index: 2000;
    background: #595758;
    font-size: 14px;
    .mc_navbar_r {
      color: #ffffff;
      .active {color: #EA6828; font-size: 16px;}
    }
  }
}
</style>
